import React, { ReactNode } from "react";
import { useDrag, useDrop } from "react-dnd";

interface DragItem {
  index: number;
  type: string;
}

interface DraggableCardProps {
  index: number;
  type: string;
  onMoveCard: (dragIndex: number, hoverIndex: number) => void;
  children: ReactNode;
}

const DraggableCard: React.FC<DraggableCardProps> = ({
  index,
  type,
  onMoveCard,
  children,
}) => {
  const [{ isDragging }, ref] = useDrag({
    type,
    item: { index },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  const [{ isOver }, drop] = useDrop({
    accept: type,
    hover: (item: DragItem) => {
      if (item.index !== index) {
        onMoveCard(item.index, index);
        item.index = index;
      }
    },
    collect: (monitor) => ({
      isOver: monitor.isOver(),
    }),
  });

  return (
    <div
      ref={(node) => ref(drop(node))}
      style={{
        width: "100%",
        cursor: isDragging ? "grabbing" : "grab",
        border: isOver ? "2px dashed #82e1f2" : "2px solid transparent",
        borderRadius: "8px",
        boxShadow: isOver ? "0 0 10px rgba(130, 225, 242, 0.5)" : "none",
        transition: "border 0.2s ease",
      }}
    >
      {children}
    </div>
  );
};

export default DraggableCard;
